module.exports = __webpack_public_path__ + "img/CustomFields-1.e78be6be.png";